const flexGrowRules = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
};

export const getPivotContainerStyle = () => ({
  pivotContentContainer: {
    ...flexGrowRules,
  },
  pivotTabContent: {
    ...flexGrowRules,
  },
  addMediaContainer: {
    '& .add-media-tab-Upload': {
      marginTop: 24,
    },
    '& .add-media-tab-StockImages': {
      marginTop: 2,
    },
    '& .add-media-tab-WebsiteImages': {
      marginTop: 8,
    },
    '& .add-media-tab-SocialMedia': {
      marginTop: 24,
    },
    ...flexGrowRules,
  },
});
